import { useEffect, useRef } from "react";
import "@tableau/embedding-api";

/**
 * Props:
 *  - src: full Tableau VIEW url
 *  - height: number | string (e.g., 681 or "82vh")
 *  - toolbar: "top" | "bottom" | "hidden"
 *  - device: "default" | "desktop" | "tablet" | "phone"
 *  - token: Direct Trust JWT from your backend
 *  - filters: optional { [fieldName]: value | value[] }
 */
export default function TableauViz({
  src,
  token,
  height = 681,
  toolbar = "bottom",
  device = "default",
  filters,
  style,
}) {
  const ref = useRef(null);

  // Apply filters once the viz is ready
  useEffect(() => {
    const el = ref.current;
    if (!el || !filters) return;

    const applyFilters = async () => {
      for (const [field, val] of Object.entries(filters)) {
        await el.setFilterAsync(field, val);
      }
    };

    const onReady = async () => {
      try { await applyFilters(); } finally {
        el.removeEventListener("firstinteractive", onReady);
      }
    };

    if (el.viz) applyFilters();
    else el.addEventListener("firstinteractive", onReady);
  }, [filters]);

  return (
    <tableau-viz
      ref={ref}
      src={src}
      token={token || ""}
      device={device}
      toolbar={toolbar}
      style={{ width: "100%", height, ...style }}
    />
  );
}